import { createConfirmation } from "react-confirm";
import AddCookTableDialog from "./AddCookTableDialog";

export const showAddCookTableDialog = createConfirmation(AddCookTableDialog);
